import data from "./productsData.json";
export const productsRange = {
  Televisions: [...data],
  Mattresses: [],
};
